import React from 'react'
import WebRegataIcon from '~/images/webregata.svg'
import Get8Icon from '~/images/get8.svg'
import RocketIcon from '~/images/rocket.svg'

export const OurPartners: React.FC = () => {
  const [hoverIcon, setHover] = React.useState('')
  const getHover = (elem: string) => (
    setHover(elem)
  )
  return (
    <>
      <div className='onlinepbx__partners__our'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__partners__our__header'>
            <span className='onlinepbx__content__header__green'>1400+</span> партнеров уже зарабатывают с <span
              className='onlinepbx__content__header__green'>online</span>
            <span
              className='onlinepbx__content__header__black'>pbx</span>
          </h2>
          <div className='onlinepbx__partners__our__logos'>
            <div className='onlinepbx__partners__our__logo'>
              <WebRegataIcon className='onlinepbx__partners__our__logo__icon' />
            </div>
            <div className='onlinepbx__partners__our__logo'>
              <Get8Icon className='onlinepbx__partners__our__logo__icon' />
            </div>
            <div className='onlinepbx__partners__our__logo'>
              <RocketIcon className='onlinepbx__partners__our__logo__icon' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurPartners
